"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CaseStudyOne() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="4037" id="case-study-one" className="bg-background text-foreground relative py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
      backgroundImage: "radial-gradient(var(--secondary) 1px, transparent 1px)",
      backgroundSize: "32px 32px"
    }} aria-hidden="true" />

      <div ref={ref} className="relative max-w-7xl mx-auto">
        <div className="flex items-center gap-4 mb-12 md:mb-16">
          <span className="font-mono text-xs font-bold tracking-[0.2em] uppercase text-primary">
            Engineering sector
          </span>
          <span className="h-px w-12 bg-border" aria-hidden="true" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-7">
            <h2 className="font-default font-bold text-2xl sm:text-3xl md:text-4xl lg:text-[3.5rem] leading-[1.1] tracking-tight text-secondary">
              78 employees on long-term sick leave. 18 months later: 2.
            </h2>
          </div>
          <div className="lg:col-span-5 flex flex-col justify-end gap-6">
            <div className={`space-y-6 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground">
                <strong className="text-secondary block mb-2">The Challenge:</strong>
                A leading engineering firm was struggling with high levels of long-term sickness absence, primarily driven by stress and musculoskeletal issues, impacting project delivery and team morale.
              </p>
              <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground">
                <strong className="text-secondary block mb-2">The Approach:</strong>
                We implemented a targeted wellbeing strategy focusing on early intervention, manager training for mental health awareness, and ergonomic workplace adjustments tailored to engineering environments.
              </p>
              <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground">
                <strong className="text-secondary block mb-2">The Result:</strong>
                Within 18 months, the number of employees on long-term sick leave plummeted from 78 to just 2, resulting in significant cost savings and a revitalised, more resilient workforce.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}